/**
 * Magento Enterprise Edition
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Magento Enterprise Edition End User License Agreement
 * that is bundled with this package in the file LICENSE_EE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://www.magento.com/license/enterprise-edition
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@magento.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade Magento to newer
 * versions in the future. If you wish to customize Magento for your
 * needs please refer to http://www.magento.com for more information.
 *
 * @category    Mage
 * @package     js
 * @copyright Copyright (c) 2006-2016 X.commerce, Inc. and affiliates (http://www.magento.com)
 * @license http://www.magento.com/license/enterprise-edition
 */

var dlCurrencyCode = (global.dlCurrencyCode = '')
var dataLayer = (window.dataLayer = window.dataLayer || [])
var staticImpressions = (global.staticImpressions = [])
var staticPromotions = (global.staticPromotions = [])
var updatedImpressions = (global.updatedImpressions = [])
var updatedPromotions = (global.updatedPromotions = [])
var cookieAddToCart = (global.cookieAddToCart = 'add_to_cart')
var cookieRemoveFromCart = (global.cookieRemoveFromCart = 'remove_from_cart')
var bannerCounter = (global.bannerCounter = 0)
var googleAnalyticsUniversalData = (global.googleAnalyticsUniversalData = googleAnalyticsUniversalData || {
    shoppingCartContent: []
})

// Set custom dimension before all other datalayer events
dataLayer.push({
    event: 'addinginCustomDimData',
    'U: Internal cookie': decodeURIComponent(Cookies.get('internal'))
})

function GoogleAnalyticsUniversal() {}
window.GoogleAnalyticsUniversal = GoogleAnalyticsUniversal
GoogleAnalyticsUniversal.prototype = {
    activeOnCategory: function (id, name, category, list, position) {
        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: list,
                        action: 'click'
                    },
                    products: [
                        {
                            id: id,
                            name: name,
                            category: category,
                            list: list,
                            position: position
                        }
                    ]
                }
            }
        })
    },
    activeOnProducts: function (
        id,
        name,
        list,
        position,
        listPosition,
        category,
        brand,
        variant
    ) {
        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: list,
                        action: 'click'
                    },
                    products: [
                        {
                            id: id,
                            name: name,
                            list: list,
                            position: position,
                            listPosition: listPosition,
                            category: category,
                            brand: brand,
                            variant: variant
                        }
                    ]
                }
            }
        })
    },
    addToCart: function (
        id,
        name,
        price,
        quantity,
        category,
        categoryId,
        brand,
        variant,
        list
    ) {
        var eventData = {
          event: 'addToCart',
          ecommerce: {
            currencyCode: dlCurrencyCode,
            add: {
              products: [
                {
                  id: id,
                  name: name,
                  price: price,
                  quantity: quantity,
                  category: category,
                  brand: brand,
                  list: list,
                  variant: variant
                }
              ]
            }
          }
        };
        if (list != undefined && list != '') {
          eventData.ecommerce.add.actionField = {
            list: list,
          }
        }
        dataLayer.push(eventData)
    },
    clickBanner: function (id, name, creative, position) {
        dataLayer.push({
            event: 'promotionClick',
            ecommerce: {
                promoClick: {
                    promotions: [
                        {
                            id: id,
                            name: name,
                            creative: creative,
                            position: position
                        }
                    ]
                }
            }
        })
    },
    activateFilter: function (filterType, filterLabel) {
      dataLayer.push({
        event: 'filters',
        filterType: filterType,
        filterLabel: filterLabel
      })
    },

    prebasketPopup: function (idRecepty) {
      dataLayer.push({
        event: 'prebasket_popup',
        id_recepty: idRecepty
      })
    },

    bindImpressionClick: function (
        id,
        type,
        name,
        category,
        list,
        position,
        blockType,
        listPosition,
        brand,
        variant
    ) {
        var productLink = []
        var eventBlock
        var linkPosition = listPosition - 1
        switch (blockType) {
            case 'Product_repleceament':
                eventBlock = '#product-replacement'
                break
            case 'Recommended_products':
                eventBlock = '.product-recommended'
                break
            case 'product.info.upsell':
                eventBlock = '.box-up-sell'
                break
            case 'checkout.cart.crosssell':
                eventBlock = '.crosssell'
                break
            case 'product_list':
            case 'search_result_list':
                eventBlock = '.category-products'
                break
            case 'search_suggester_list':
                eventBlock = '.suggester__list'
                break
            case 'home_list':
                eventBlock = '.product-list'
        }
        productLink = document.querySelectorAll(
            eventBlock + ' .item:nth(' + linkPosition + ') a'
        )
        if (type == 'configurable' || type == 'bundle' || type == 'grouped') {
            productLink = document.querySelectorAll(
                eventBlock + ' .item:nth(' + linkPosition + ') .btn-cart',
                eventBlock + ' .item:nth(' + linkPosition + ') a'
            )
        }
        productLink.each(function (element) {
            element.addEventListener('click', function (event) {
                googleAnalyticsUniversal.activeOnProducts(
                    id,
                    name,
                    list,
                    position,
                    listPosition,
                    category,
                    brand,
                    variant
                )
            })
        })
    },

    listenImpressionClick: function (container) {
        var gtmElements = container
            ? container.querySelectorAll('[data-gtm-element="product-item"]')
            : document.querySelectorAll('[data-gtm-element="product-item"]')
        Array.from(gtmElements).forEach((el) => {
            el.removeEventListener('click', this.gtmClickEvent)
            el.addEventListener('click', this.gtmClickEvent)
        })
    },

    gtmClickEvent: function (e) {
        var product = this;
        var cartButton = product.querySelector('[data-vue-init="add-to-cart"]')
        if (cartButton && (e.target === cartButton || cartButton.contains(e.target))) {
          return
        }

        var productLocalData = JSON.parse(product.parentNode.getAttribute('data-gtm'));
        var productData = [];
        if (productLocalData) {
            productData['id'] = productLocalData.id;
            productData['name'] = productLocalData.name;
            productData['list'] = productLocalData.list;
            productData['position'] = productLocalData.position;
            productData['listPosition'] = productLocalData.listPosition;
            productData['category'] = productLocalData.category;
            productData['brand'] = productLocalData.brand;
            productData['variant'] = productLocalData.variant;
        } else {
            var product_index = product.getAttribute('data-gtm-product-id');
            productData = window.staticImpressions[product_index];
        }

        if (productData == undefined) {
          return;
        }

        googleAnalyticsUniversal.activeOnProducts(
            productData['id'],
            productData['name'],
            productData['list'],
            productData['position'],
            productData['listPosition'],
            productData['category'],
            productData['brand'],
            productData['variant']
        )
    },

    updateImpressions: function (impression) {
        var pageImpressions

        if (typeof impression !== 'undefined') {
            pageImpressions = this.mergeImpressions(impression)
        } else {
            pageImpressions = this.mergeImpressions()
        }

        var dlImpressions = {
            event: 'productImpression',
            ecommerce: {
                impressions: []
            }
        }
        var impressionCounter = 0

        for (blockName in pageImpressions) {
            if (
                blockName === 'length' ||
                !pageImpressions.hasOwnProperty(blockName)
            )
                continue
            for (var i = 0; i < pageImpressions[blockName].length; i++) {
                var impression = pageImpressions[blockName][i]
                dlImpressions.ecommerce.impressions.push({
                    id: impression.id,
                    name: impression.name,
                    category: impression.category,
                    list: impression.list,
                    listPosition: impression.listPosition,
                    position: impression.position,
                    brand:
                        typeof impression.brand != 'undefined'
                            ? impression.brand
                            : '',
                    type:
                        typeof impression.type != 'undefined'
                            ? impression.type
                            : '',
                    variant:
                        typeof impression.variant != 'undefined'
                            ? impression.variant
                            : ''
                })
                impressionCounter++
                // this.bindImpressionClick(impression.id, impression.type, impression.name,
                //     impression.category, impression.list, impression.position, blockName, impression.listPosition,
                //     impression.brand, impression.variant);
            }
        }

        // P150A-2346: "Najlepiej będzie, jak zupełnie przestaniemy wysyłać push productImpressions (nie ma potrzeby zaśmiecać dataLayer"
        //if (impressionCounter > 0) {
        //    dataLayer.push(dlImpressions);
        //}
    },

    pushImpressions: function (impression) {
        var dlImpressions = {
            event: 'productImpression',
            ecommerce: {
                impressions: []
            }
        }

        var impressionCounter = 0
        for (var i = 0; i < impression.length; i++) {
            dlImpressions.ecommerce.impressions.push({
                id: impression[i].id,
                name: impression[i].name,
                category: impression[i].category,
                list: impression[i].list,
                listPosition: impression[i].listPosition,
                position: impression[i].position,
                brand:
                    typeof impression[i].brand != 'undefined'
                        ? impression[i].brand
                        : '',
                type:
                    typeof impression[i].type != 'undefined'
                        ? impression[i].type
                        : '',
                variant:
                    typeof impression[i].variant != 'undefined'
                        ? impression[i].variant
                        : ''
            })
            impressionCounter++
            // this.bindImpressionClick(impression.id, impression.type, impression.name,
            //     impression.category, impression.list, impression.position, blockName, impression.listPosition,
            //     impression.brand, impression.variant);
        }

        if (impressionCounter > 0) {
            dataLayer.push(dlImpressions)
        }
    },

    mergeImpressions: function (block) {
        var blockNames = [],
            pageImpressions = []

        if (typeof block !== 'undefined') {
            blockNames = [block]
        } else {
            blockNames = [
                'product_list',
                'product.info.upsell',
                'Related_products',
                'Recommended_products',
                'Product_repleceament',
                'checkout.cart.crosssell',
                'search_result_list',
                'search_suggester_list'
            ]
        }

        blockNames.forEach(function (blockName) {
            // check if there is a new block generated by FPC placeholder update
            if (blockName in updatedImpressions) {
                pageImpressions[blockName] = updatedImpressions[blockName]
            } else {
                // use the static data otherwise
                pageImpressions = staticImpressions
            }
        })

        return pageImpressions
    },

    updatePromotions: function () {
        var dlPromotions = {
            event: 'promotionView',
            ecommerce: {
                promoView: {
                    promotions: []
                }
            }
        }
        var pagePromotions = []
        // check if there is a new block generated by FPC placeholder update
        if (updatedPromotions.length) {
            pagePromotions = updatedPromotions
        }
        // use the static data otherwise
        if (pagePromotions.length == 0 && staticPromotions.length) {
            pagePromotions = staticPromotions
        }
        var promotionCounter = 0
        for (var i = 0; i < pagePromotions.length; i++) {
            var promotion = pagePromotions[i]
            var banner = document.getElementById('promo-box_' + promotion.id)

            dlPromotions.ecommerce.promoView.promotions.push({
                id: promotion.id,
                name: promotion.name,
                creative: promotion.creative,
                position: promotion.position
            })
            promotionCounter++
            this.bindPromotionClick(
                banner,
                promotion.id,
                promotion.name,
                promotion.creative,
                promotion.position
            )
        }
        if (promotionCounter > 0) {
            dataLayer.push(dlPromotions)
        }
    },

    addPromotion: function (id, name, position, creative) {
        dataLayer.push({
            event: 'promoSlider',
            ecommerce: {
                promoView: {
                    promotions: [
                        {
                            id: id,
                            name: name,
                            position: position,
                            creative: creative
                        }
                    ]
                }
            }
        })
    },

    bindPromotionClick: function (banner, id, name, creative, position) {
        banner.addEventListener('click', function (event) {
            googleAnalyticsUniversal.clickBanner(id, name, creative, position)
        })
    },

    virtualPage: function (url, pageTitle) {
        dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: url,
            virtualPageTitle: pageTitle
        })
    },

    pharmacyEvent: function (eventName, pharmacy_code) {
        dataLayer.push({
            event: eventName,
            pharmacy_code: pharmacy_code
        })
    },

    notifyUnavailable: function () {
        dataLayer.push({
            event: 'Notify Unavailable'
        })
    },

    errorSend: function (data) {
        var dataLayer = (window.dataLayer = window.dataLayer || [])

        data.label =
            typeof data.label === 'undefined'
                ? (data.label = window.location.href)
                : data.label

        switch (data.category) {
            case 1:
                data.category = 'Popup error'
                break
            case 2:
            case 'Checkout error':
                data.category = 'Checkout error'
                break
            default:
                data.category = 'Validation error'
        }

        dataLayer.push({
            event: 'error',
            category: data.category,
            label: data.label,
            action: data.action,
            code: data.code != undefined ? data.code : '',
            additionalData: data.additionalData
        })
    }
}

GoogleAnalyticsUniversalCart = function () {
    this.productQtys = []
    this.origProducts = {}
    this.productWithChanges = []
    this.addedProducts = []
    this.removedProducts = []
}
GoogleAnalyticsUniversalCart.prototype = {
    // ------------------- shopping cart ------------------------
    listenMinicartReload: function () {
        var context = this
        if (
            typeof Minicart != 'undefined' &&
            typeof Minicart.prototype.initAfterEvents
        ) {
            Minicart.prototype.initAfterEvents[
                'GoogleAnalyticsUniversalCart:subscribeProductsUpdateInCart'
            ] = function () {
                context.subscribeProductsUpdateInCart()
                context.parseAddToCartCookies()
                context.parseRemoveFromCartCookies()
            }
            // if we are removing last item init don't calling
            Minicart.prototype.removeItemAfterEvents[
                'GoogleAnalyticsUniversalCart:subscribeProductsRemoveFromCart'
            ] = function () {
                context.parseRemoveFromCartCookies()
            }
        }
    },
    subscribeProductsUpdateInCart: function () {
        var context = this
        document
            .querySelectorAll('[data-cart-item-update]')
            .forEach(function (element) {
                document.getElementById(element).removeEventListener('click')
                document
                    .getElementById(element)
                    .addEventListener('click', function () {
                        context.updateCartObserver()
                    })
            })
        document
            .querySelectorAll('[data-multiship-item-update]')
            .forEach(function (element) {
                document.getElementById(element).removeEventListener('click')
                document
                    .getElementById(element)
                    .addEventListener('click', function () {
                        context.updateMulticartCartObserver()
                    })
            })
        document
            .querySelectorAll('[data-cart-empty]')
            .forEach(function (element) {
                document.getElementById(element).removeEventListener('click')
                document
                    .getElementById(element)
                    .addEventListener('click', function () {
                        context.emptyCartObserver()
                    })
            })
    },
    emptyCartObserver: function () {
        this.collectOriginalProducts()
        for (var i in this.origProducts) {
            if (i != 'length' && this.origProducts.hasOwnProperty(i)) {
                var product = Object.extend({}, this.origProducts[i])
                this.removedProducts.push(product)
            }
        }
        this.cartItemRemoved()
    },
    updateMulticartCartObserver: function () {
        this.collectMultiProductsWithChanges()
        this.collectProductsForMessages()
        this.cartItemAdded()
        this.cartItemRemoved()
    },
    updateCartObserver: function () {
        this.collectProductsWithChanges()
        this.collectProductsForMessages()
        this.cartItemAdded()
        this.cartItemRemoved()
    },
    collectMultiProductsWithChanges: function () {
        this.collectOriginalProducts()
        this.collectMultiCartQtys()
        this.productWithChanges = []
        var groupedProducts = {}
        for (var i = 0; i < this.productQtys.length; i++) {
            var cartProduct = this.productQtys[i]
            if (typeof groupedProducts[cartProduct.id] == 'undefined') {
                groupedProducts[cartProduct.id] = parseInt(cartProduct.qty, 10)
            } else {
                groupedProducts[cartProduct.id] += parseInt(cartProduct.qty, 10)
            }
        }
        for (var j in groupedProducts) {
            if (groupedProducts.hasOwnProperty(j)) {
                if (
                    typeof this.origProducts[j] != 'undefined' &&
                    groupedProducts[j] != this.origProducts[j].qty
                ) {
                    var product = Object.extend({}, this.origProducts[j])
                    product['qty'] = groupedProducts[j]
                    this.productWithChanges.push(product)
                }
            }
        }
    },
    collectProductsWithChanges: function () {
        this.collectOriginalProducts()
        this.collectCartQtys()
        this.productWithChanges = []
        for (var i = 0; i < this.productQtys.length; i++) {
            var cartProduct = this.productQtys[i]
            if (
                typeof this.origProducts[cartProduct.id] != 'undefined' &&
                cartProduct.qty != this.origProducts[cartProduct.id].qty
            ) {
                var product = Object.extend(
                    {},
                    this.origProducts[cartProduct.id]
                )
                if (parseInt(cartProduct.qty, 10) > 0) {
                    product['qty'] = cartProduct.qty
                    this.productWithChanges.push(product)
                }
            }
        }
    },
    collectOriginalProducts: function () {
        if (
            googleAnalyticsUniversalData &&
            googleAnalyticsUniversalData['shoppingCartContent']
        ) {
            this.origProducts =
                googleAnalyticsUniversalData['shoppingCartContent']
        }
    },
    collectMultiCartQtys: function () {
        var productQtys = []
        document
            .querySelectorAll('[data-multiship-item-id]')
            .forEach(function (element) {
                productQtys.push({
                    id: document
                        .getElementById(element)
                        .readAttribute('data-multiship-item-id'),
                    qty: document.getElementById(element).getValue()
                })
            })
        this.productQtys = productQtys
    },
    collectCartQtys: function () {
        var productQtys = []
        document
            .querySelectorAll('[data-cart-item-id]')
            .forEach(function (element) {
                productQtys.push({
                    id: document
                        .getElementById(element)
                        .readAttribute('data-cart-item-id'),
                    qty: document.getElementById(element).getValue()
                })
            })
        this.productQtys = productQtys
    },
    collectProductsForMessages: function () {
        this.addedProducts = []
        this.removedProducts = []
        for (var i = 0; i < this.productWithChanges.length; i++) {
            var product = this.productWithChanges[i]
            if (typeof this.origProducts[product.id] != 'undefined') {
                if (product.qty > this.origProducts[product.id].qty) {
                    product.qty = Math.abs(
                        this.origProducts[product.id].qty - product.qty
                    )
                    this.addedProducts.push(product)
                } else if (
                    product.qty < this.origProducts[product.id].qty &&
                    product.qty != 0
                ) {
                    product.qty =
                        product.qty - this.origProducts[product.id].qty
                    this.addedProducts.push(product)
                } else {
                    product.qty = Math.abs(
                        product.qty - this.origProducts[product.id].qty
                    )
                    this.removedProducts.push(product)
                }
            }
        }
    },
    formatProductsArray: function (productsIn) {
        var productsOut = []
        var itemId
        for (var i in productsIn) {
            if (i != 'length' && productsIn.hasOwnProperty(i)) {
                if (typeof productsIn[i]['sku'] != 'undefined') {
                    itemId = productsIn[i].sku
                } else {
                    itemId = productsIn[i].id
                }
                productsOut.push({
                    id: itemId,
                    name: productsIn[i].name,
                    price: productsIn[i].price,
                    quantity: parseInt(productsIn[i].qty, 10),
                    category:
                        typeof productsIn[i].category != 'undefined'
                            ? productsIn[i].category
                            : '',
                    brand:
                        typeof productsIn[i].brand != 'undefined'
                            ? productsIn[i].brand
                            : '',
                    variant:
                        typeof productsIn[i].variant != 'undefined'
                            ? productsIn[i].variant
                            : ''
                })
            }
        }
        return productsIn
    },
    cartItemAdded: function () {
        if (this.addedProducts.length == 0) {
            return
        }
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: dlCurrencyCode,
                add: {
                    products: this.formatProductsArray(this.addedProducts)
                }
            }
        })
        this.addedProducts = []
    },
    cartItemRemoved: function () {
        if (this.removedProducts.length == 0) {
            return
        }
        dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                currencyCode: dlCurrencyCode,
                remove: {
                    products: this.formatProductsArray(this.removedProducts)
                }
            }
        })
        this.removedProducts = []
    },
    parseAddToCartCookies: function () {
        if (Cookies.get(cookieAddToCart)) {
            this.addedProducts = []
            var addProductsList = decodeURIComponent(
                Cookies.get(cookieAddToCart)
            )
            this.addedProducts = JSON.parse(addProductsList)
            Cookies.remove(cookieAddToCart)
            this.cartItemAdded()
        }
    },
    parseRemoveFromCartCookies: function () {
        if (Cookies.get(cookieRemoveFromCart)) {
            var cookieDomain =
                window.JSAPP_CONFIG['COOKIE_DOMAIN'] || '.apteline.pl'

            this.removedProducts = []
            var removeProductsList = decodeURIComponent(
                Cookies.get(cookieRemoveFromCart)
            )
            this.removedProducts = JSON.parse(removeProductsList)
            Cookies.remove(cookieRemoveFromCart, {
                path: '/',
                domain: cookieDomain
            })
            this.cartItemRemoved()
        }
    }
}

var googleAnalyticsUniversal = new GoogleAnalyticsUniversal()
var googleAnalyticsUniversalCart = new GoogleAnalyticsUniversalCart()

document.addEventListener('DOMContentLoaded', function () {
    googleAnalyticsUniversal.updatePromotions()
    //googleAnalyticsUniversal.updateImpressions();
    // googleAnalyticsUniversal.listenImpressionClick()
    googleAnalyticsUniversalCart.parseAddToCartCookies()
    googleAnalyticsUniversalCart.parseRemoveFromCartCookies()
    googleAnalyticsUniversalCart.subscribeProductsUpdateInCart()
    googleAnalyticsUniversalCart.listenMinicartReload()
    dataLayer.apteline_logged_in = parseInt(
        Cookies.get('aoestatic_w1_isloggedin')
    )
        ? 1
        : 0
})

document.addEventListener('validation:failed', function (ev) {
    googleAnalyticsUniversal.errorSend(ev.memo.data)
})
